import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@material-ui/core";
import React, {useState} from "react";
import {DeleteIcon} from "../banners/advertisersComponent";
import bannerService from "../../services/banner";
import Utility from "../../utility";


const DeleteDialogComponent = (props) => {
    const {entityName, id, refreshList} = props
    const [isOpen, setOpen] = useState(false)

    const onDelete = async () => {
        setOpen(false)
        await Utility.parseResponse(bannerService.deleteEntity(entityName, id));
        refreshList()
    }

    return (
        <>
            <DeleteIcon src="/images/delete.png" onClick={() => setOpen(true)}/>

            <Dialog
                open={isOpen}
                onClose={() => setOpen(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {`Are you sure?`}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {`This ${entityName} will not be visible in app once you delete this...`}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)}>Cancel</Button>
                    <Button onClick={onDelete} autoFocus>
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )

}

export default DeleteDialogComponent
